(function () {
  'use strict';
  // Unpublished-theme display enhancement only; preserves each item's own care directions.
  function normalizeCareProtocol(root) {
    (root || document).querySelectorAll('details').forEach(function (section) {
      var summary = section.querySelector(':scope > summary');
      if (!summary || !/Care Protocol/i.test(summary.textContent || '')) return;
      var content = Array.prototype.find.call(section.children, function (child) {
        return child !== summary && child.tagName !== 'SUMMARY';
      });
      if (!content) return;
      if (content.querySelector('[data-kolak-care-reference]')) return;
      if (content.querySelector('a[href*="/pages/care-protocol"]')) return;
      var note = document.createElement('p');
      note.setAttribute('data-kolak-care-reference', 'true');
      note.style.margin = '10px 0 0';
      note.textContent = "For material-specific guidance, see the item's care label and the ";
      var link = document.createElement('a');
      link.href = '/pages/care-protocol';
      link.textContent = 'KOLAK Care Protocol';
      note.appendChild(link);
      note.appendChild(document.createTextNode('.'));
      content.appendChild(note);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { normalizeCareProtocol(document); });
  else normalizeCareProtocol(document);
  document.addEventListener('shopify:section:load', function (event) { normalizeCareProtocol(event.target); });
})();